export async function initGameWindowMobile() {
  /**
Initializes the game window navigation.
*/
  initGameWindowNav();
}
async function initGameWindowNav() {
  const basicFunctions = await import('../../../tools/basic-functions');
  const [gamePopupNode, gameWindow] = document.querySelectorAll('.modal-game-mode-popup, .js-game-mode-popup');

  /**
Initializes the game window navigation handler.

@param {string} triggerSelector - The class name of the trigger element.
@param {string} activeSelector - The class name of the active element.
@param {Function} onTriggerClick - The function to execute after the action.
@param {Function} onModalAction - The function to execute if a modal is open.
*/
  const initGameWindowNavHandler = (triggerSelector, activeSelector, onTriggerClick, onModalAction) => {
    const activeElement = activeSelector ? gameWindow.querySelector(activeSelector) : null;

    gameWindow.addEventListener('click', (event) => {
      const triggerElement = event.target;
      if (!triggerElement.closest(triggerSelector)) return;
      event.preventDefault();
      let modalOpen = false;

      if (activeElement) {
        const isActive = activeElement.classList.contains('active');
        if (isActive) {
          activeElement.classList.remove('active');
        } else {
          modalOpen = closeModals();
          activeElement.classList.add('active');
        }
      } else modalOpen = closeModals();

      if (onTriggerClick) onTriggerClick();

      if (onModalAction) onModalAction(modalOpen);
    });
  };

  // Handles the back button.
  initGameWindowNavHandler('.js-game-back-button', null, null, (status) => {
    if (status) return;

    basicFunctions.simulateClick(gamePopupNode.querySelector('.js-back'));
    basicFunctions.simulateClick(gameWindow.querySelector('.close'));
  });

  // Handles the search button.
  initGameWindowNavHandler('.js-open-search', '.search');

  // Handles the ecchest popup.
  initGameWindowNavHandler('.js-cms-open-ecchest-popup', '.js-cms-ecchest-popup', () => {
    document.querySelector('.js-cms-ecchest-popup .progressbar-bar-progress').style.width = document.querySelector(
      '.js-cms-ecchest-popup .js-progress'
    ).innerHTML;
  });

  // Handles the tournament button.
  //initGameWindowNavHandler(".js-open-tournament", ".module-tournaments");

  // Handles the cashback button.
  //initGameWindowNavHandler(".js-open-cashback", ".module-cashback-modal");

  /*initGameWindowNavHandler(
    ".js-open-favourite-games",
    ".module-favorite-games"
  );*/

  // Handles tab switching.
  gameWindow.querySelector('.js-switch')?.addEventListener('click', (event) => {
    switchTab(event.target);
  });
}

/**
Closes any open modals in the game window.

@returns {boolean} - True if a modal was closed, false otherwise.
*/
const closeModals = () => {
  const modalList = Array.from(document.querySelectorAll('.modal-game-mode-popup .modal-cms'));
  const modalsToRemove = modalList.filter((modal) => modal.classList.contains('active'));
  modalsToRemove.forEach((modal) => modal.classList.remove('active'));

  return modalsToRemove.length > 0;
};

/**
Switches tabs in the game window.

@param {HTMLElement} element - The element to switch to.
*/
const switchTab = (element) => {
  const { classList, parentNode } = element;

  if (!classList.contains('btn') || classList.contains('active')) {
    return;
  }

  const activeElement = parentNode.querySelector('.active');
  activeElement.classList.remove('active');

  classList.add('active');

  const switchContentList = document.querySelectorAll('.js-switch-content');

  for (const switchContent of switchContentList) {
    switchContent.classList.toggle('d-none');
  }
};

/**
 * creates game popup
 * @param {Number} gameId
 * @returns game popup node
 */
export async function initGameModePopupHandler(gameId) {
  const { initPopupGamesDescriptions } = await import('@games/both/game-descriptions/games-descriptions.js'),
    { getAllGames } = await import('../../get-all-games'),
    { findGameById, getGameLinkCategory } = await import('../../utilities');

  const gamesListObj = await getAllGames();
  const game = findGameById(gamesListObj, gameId);
  if (!game || game.coming_soon || game.maintenance) return;

  const gamePopupNode = document.querySelector('.js-game-mode-popup');

  initAttributes(game);
  initGameData(game.slug);

  initFavourites(gameId);
  initMobileGameModalGames(gamesListObj);

  if (game.tags) {
    const { initTags } = await import('../../utilities');
    gamePopupNode.querySelector('.tags ul').innerHTML = '';
    initTags(game.tags, getGameLinkCategory(game.kind), gamePopupNode.querySelector('.tags'));
  }
  initPopupGamesDescriptions(gameId);

  window['scrollTopAmount'] = window.scrollY;
  gamePopupNode.classList.add('active');
  document.body.classList.add('game-mode-popup-open');
}

export async function initGameModePopupHandlerReal(event) {
  const gameModeSwitch = document.querySelector('.gamepopup .game-mode-switch');
  if (gameModeSwitch) {
    gameModeSwitch.classList.toggle('d-none', true);
  }

  const { initCashbackProgressBar } = await import('@games/both/game-window/cashback/progress-bar');
  initCashbackProgressBar();

  const { initNotificationsService } = await import('@games/window/service/notification-service');
  initNotificationsService();

  setTimeout(async () => {
    const hasTournament = Boolean(document.querySelector('.js-gamepopup-v4.has-sidebar'));
    const gameId = event.detail.gameId;

    if (!hasTournament || !gameId) {
      return;
    }

    const { initTournament } = await import('@games/mobile/game-window/tournament/tournament');
    initTournament(parseInt(gameId));
  }, 1000);
}

async function initMobileGameModalGames(gamesList) {
  const { getLastPlayedGamesCollections } = await import('../../get-all-games');
  let lastPlayed = await getLastPlayedGamesCollections();
  if (lastPlayed.items) {
    const { arrayOrder } = await import('../../../tools/basic-functions.js');
    const { removeGamesIfNotInArray } = await import('../../utilities');
    gamesList = removeGamesIfNotInArray(gamesList, lastPlayed.items);
    gamesList = arrayOrder(gamesList, lastPlayed.items, 'id').slice(0, 25);
  } else {
    const { getRecommendedGames } = await import('../../collections');
    gamesList = await getRecommendedGames(gamesList, 20);
  }
  const { createGames } = await import('../../games');
  createGames(gamesList, 'recommended', true, true);
}

async function initFavourites(gameId) {
  const { checkFavoriteGame } = await import('../../utilities');
  const isFaved = await checkFavoriteGame(gameId);

  const favElementPopup = document.querySelector('.js-game-mode-popup .js-favourites');
  const favElementWindow = document.querySelector('.js-gamepopup-v4 .js-toggle-modal-favourite');

  favElementPopup.classList.toggle('js-faved', isFaved);
  favElementWindow.classList.toggle('js-faved', isFaved);
}

async function initGameData(slugName) {
  const { getGamesData } = await import('../../get-all-games');

  const { gameRating, gameVotes, shortDesc } = await getGamesData(slugName);
  const gamePopup = document.querySelector('.js-game-mode-popup');

  gamePopup.querySelector('.js-avarage').setAttribute('game-rating', gameRating ?? '4.8');

  gamePopup.querySelector('.js-avarage').innerHTML = gameRating ? parseFloat(gameRating) : '4.8';

  gamePopup.querySelector('.js-amount').innerHTML = gameVotes ?? '1252';

  gamePopup.querySelector('.paragraph').innerHTML = shortDesc ? '<p>' + shortDesc + '...</p>' : '';
}

async function initAttributes(game) {
  const { getGameLinkCategory } = await import('../../utilities');

  const gamePopup = document.querySelector('.js-game-mode-popup');
  const langLocale = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE;
  const gameUrl = `/${langLocale}/${getGameLinkCategory(game.kind)}/${game.slug}`;

  const thumbsnailSrc = `/images/uploads/games-thumbs/${
    _CMS_MOBILE ? 'x175' : 'x300'
  }${_CMS_USERIP == 'gb' ? '-uk' : ''}`;

  const gameRunReal = gamePopup.querySelector('.mobile-game-real');
  const gameRunDemo = gamePopup.querySelector('.mobile-game-demo');

  const gameElement = document.querySelector('.game[data-game-id="' + game.id + '"]');

  if (!gameElement) {
    return;
  }

  const tournamentId = gameElement.getAttribute('data-tournament-id');

  gamePopup.setAttribute('data-game-id', game.id);

  gamePopup.querySelector('.js-info').setAttribute('href', gameUrl);

  gamePopup.classList.toggle('js-tournament', tournamentId);

  gameRunReal.classList.remove('loading');
  gameRunReal.setAttribute('data-game-id', game.id);
  gameRunReal.classList.toggle('js-tournament', tournamentId);

  gameRunDemo.classList.remove('loading');
  gameRunDemo.classList.toggle('d-none', !game.demo);
  gameRunDemo.setAttribute('data-game-id', game.demo ? game.id : '');

  gamePopup.querySelector('.js-game-title').innerHTML = game.name;

  gamePopup.querySelector('.game-bg img').src = thumbsnailSrc + '/' + game.id + '.jpg';
  gamePopup.querySelector('.game-movie img').src = thumbsnailSrc + '/' + game.id + '.jpg';

  gamePopup.querySelector('.js-share').setAttribute('data-share-title', game.name);

  gamePopup.querySelector('.js-share').setAttribute('data-slug', game.slug);

  if (tournamentId) {
    gamePopup.setAttribute('data-tournament-id', tournamentId);
    gameRunReal.setAttribute('data-tournament-id', tournamentId);
  } else {
    gamePopup.removeAttribute('data-tournament-id');
    gameRunReal.removeAttribute('data-tournament-id');
  }
}

export async function stopGameModePopupHandler() {
  const { destroyCashbackProgressBar } = await import('../../both/game-window/cashback/progress-bar');
  destroyCashbackProgressBar();
}
